import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link,useParams,useLocation,useNavigate  } from "react-router-dom";
import { APIURL,TZ } from "../../../Global";
import Pagination from "react-js-pagination";
import "../regdhospital.css"
import "../pagination.css";
import "../service.css"
import "../labsp.css"
import LoadingOverlay from 'react-loading-overlay';
import { ToggleButton } from 'react-bootstrap';
import { ToggleButtonGroup } from 'react-bootstrap';


function RegisteredHospitals() {
  const { state } = useLocation()
  const [selected, setSelected] = useState(state&&state.approve?"approved":"pending")
  const [loading, setLoading] = useState(false);
  const [pending, setPending] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sort,setSort]=useState("");
  const [nameSearch,setNameSearch]=useState("")
  const [locSearch,setLocSearch]=useState("")
  const [idSearch,setIdSearch]=useState("")
  const [typeSearch,setTypeSearch]=useState("")
  const [perPage,] = useState(10);const [approve, setApproved] = useState(false)
const navigate = useNavigate();
  const {status} = useParams();
 console.log(status)
 
 
 console.log(state)

  useEffect(() => {
    if(selected!=="expired"){
     
    setLoading(true)
    const tokenString = sessionStorage.getItem("usertoken");

    let v2 = tokenString.replace(
      /["]+/g,
      ""
    );
    axios.get(`${APIURL}/api/v1/staff/hospital-approve/?sort=${sort}&hospital_name=${nameSearch.trim()}&hospital_id=${idSearch.trim()}&health_care_type=${typeSearch.trim()}&location=${locSearch.trim()}&${selected==="approved" ? "status=approved" :selected==="rejected" ? "status=rejected": ""}` , {
      headers: { Authorization: "Token " + v2 },
    })
      .then((res) => {
        if (res.data.status === 'success') {
          const data = res.data.hospitals
          setPending(data)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
    }
  }, [selected,sort,nameSearch,locSearch,typeSearch,idSearch])
  const getExpClinics = () => {
    setPending([])
    const tokenString = sessionStorage.getItem('usertoken');

    let str = tokenString.replace(/["]+/g, '')
   
    axios.get(`${APIURL}/api/v1/staff/hospital-plans/?is_expired=true&${TZ}`, {
        headers: {

            "Authorization": 'Token ' + str
        }
    })
        .then(res => {

            if (res.data.status === "success") {
              
              if(res.data.details.length>0){
                let updatedList = [];
           updatedList = res.data.details.map((item)=>{
                  return {
                    "name": item.hospital_name,
                    "id": item.hospital_id,
                    "status": "expired"
                }
                })
               setPending(updatedList.length>0?updatedList:[])
              }
             
            }


        })
        .catch(err => {

        })



}

  const handleChangeRadio = (val) => {
    setApproved(val)
  }

  const handleSearchChange = (e) => {
    e.preventDefault();
    setCurrentPage(1)
    setSearchTerm(e.target.value)
  }

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  


  // let data = pending.sort((a, b) => {
  //   if (a.name.toLowerCase() < b.name.toLowerCase()) return -1;
  //   if (a.name.toLowerCase() > b.name.toLowerCase()) return 1;
  //   return 0;
  // })
  //   .filter((value) => {
  //     if (searchTerm === '') {
  //       return value
  //     } else if (value.name.toLowerCase().includes(searchTerm.toLowerCase())) {
  //       return value
  //     }
  //   })


  const indexLast = currentPage * perPage;
  const indexFirst = indexLast - perPage;
  const current = pending.slice(indexFirst, indexLast);
  const total = pending.length;

  const pageNumbers = []
  for (let i = 0; i <= Math.ceil(total / perPage); i++) {
    pageNumbers.push(i)
  }
  const totalPages = pageNumbers.length;

  let display = current.length > 0 ? current.map((data, index) => {
    let id = data.id

    return (

<> 
<div className="row " key={data.id}
              
               onClick={() => {if(data.status!=="rejected") {navigate( `/hospital-details/${id}`)}}}
             style={{fontSize:"13px",  cursor: "pointer",textAlign: "left",borderLeft:"0.4px solid gray", borderBottom:"0.4px solid gray",borderRight:"0.4px solid gray",
              boxShadow:" 2px 2px 7px rgb(0 0 0 / 30%)",marginBottom:"0.5%"}}>
<div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}} className="col-1">{data.id}</div>
                        <div style={{backgroundColor:"#BFC7DA", padding:"1%",borderRight:"0.4px solid gray"}}className= {selected==="approved"?"col-2":"col-3"}>{}{data.name}</div>
                        {selected==="approved"&& <div style={{ padding:"1%"}}className="col-1">{data.patients_count}</div>}
                    <div style={{ padding:"1%"}} className="col-2">{data.category}</div>
                    <div style={{ padding:"1%"}}className="col-2">{data.health_care_type}</div>
                    
                    <div style={{ padding:"1%"}}className="col-2">{data.date_of_joining}</div>
                    <div style={{ padding:"1%"}} className="col-2" >{data.location}</div></div>
{/* <div
              className="care-features"
              >
              <div className="">
                <h5 className="feature-title " >
                  <b>
                    {" "}
                    <span className=""
                      style={{ cursor: "pointer"}}
                      onClick={() =>  {if(data.status!=="rejected") {navigate( `/hospital-details/${id}`)}}}
                    >
                     {(currentPage - 1) * 10 + index + 1}.{data.name}{" "}
                     
                    </span>
                    <small>ID : {data.id} </small>
                  </b>

                  
                </h5>
              </div>

             
            </div> */}



   </> )
  }) : null
 
  return (
  
   <div className='row service-providers-wrapper' style={{marginTop:"1%",width:"100%",minHeight:"71vh"}}>


 
   <div className="col-3 service-sidecard-wrapper">
      <div className="service-sidecard">
        <div className="service-sidecard-header">
          <div className="service-sidecard-icon">S</div>
          <div>
            <p className="service-sidecard-title">Service providers</p>
            <p className="service-sidecard-subtitle">Manage onboarded clinics</p>
          </div>
        </div>
        <div className="service-sidecard-menu">
          <button
            className={
              selected === "pending" ? "patientRecbutton1 service-sidecard-btn active" : "patientRecbutton service-sidecard-btn"
            }
            onClick={() => {
              setSelected("pending");
            }}
          >
            Pending
          </button>
          <button
            className={
              selected === "approved" ? "patientRecbutton1 service-sidecard-btn active" : "patientRecbutton service-sidecard-btn"
            }
            onClick={() => {
              setSelected("approved");
            }}
          >
            Approved
          </button>
          <button
            className={
              selected === "rejected" ? "patientRecbutton1 service-sidecard-btn active" : "patientRecbutton service-sidecard-btn"
            }
            onClick={() => {
              setSelected("rejected");
            }}
          >
            Rejected
          </button>
          <button
            className={
              selected === "expired" ? "patientRecbutton1 service-sidecard-btn active" : "patientRecbutton service-sidecard-btn"
            }
            onClick={() => {
              setSelected("expired");
              getExpClinics();
            }}
          >
            Expired
          </button>
        </div>
      </div>
    </div>
        
     
      
         <div className="col-9 service-content-card" style={{minHeight:"71vh"}}>
          <div className="">
         
              <div className="container"  style={{ }}>
                
             {selected!=="expired"&& <div className='row'>
            
             
        <div className="col-11">
        <div className="search-div row">
                <div className="col-3" >

                  <input

                    type="text"
                    className="search-clinics"
                    placeholder="Search service provider"
                    value={nameSearch}
                    onChange={(e) =>{ setCurrentPage(1);setNameSearch(e.target.value)}}
                    // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
                  />
                 

                </div>
                <div className="col-3" >

<input

  type="text"
  className="search-clinics"
  placeholder="Search ID"
  value={idSearch}
  onChange={(e) =>{ setCurrentPage(1);setIdSearch(e.target.value)}}
  // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
/>


</div>
<div className="col-3" >

<input

  type="text"
  className="search-clinics"
  placeholder="Search location"
  value={locSearch}
  onChange={(e) =>{ setCurrentPage(1);setLocSearch(e.target.value)}}
  // style={{ paddingLeft: "10px", width: "100%",borderRadius:"5px 0px 0px 5px",border:"1px solid " }}
/>


</div>
<div className="col-3" >
<select
                        name='allergytype'
                        className="search-clinics"
                       
                        value={typeSearch}
                        onChange={(e) =>{ setCurrentPage(1);setTypeSearch(e.target.value)}}
                        >
                        <option value=""   >All</option>
                        <option value="ModernMedicine" >Modern Medicine</option>
                        <option value="Ayurveda" >Ayurveda</option>
                        <option value="Homeopathy" >Homeopathy</option>
                        <option value="Unani" >Unani</option>
                        <option value="Dental" >Dental</option>
                        <option value="Multispeciality" >Multispeciality</option>
                        <option value="Other" >Other</option>
                        
                    </select>



</div>
              </div>
        </div>
     
        <div className="col-1">
              <button className="" onClick={() =>{sort===""?setSort("asc"):setSort("")}} style={{ boxShadow: "3px 5px 10px rgba(0,0,0,0.2)", height: "40px", fontSize: "small",  color: "white", backgroundColor: "#272244", border: "none",borderRadius:"5px" }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M8 16H4l6 6V2H8zm6-11v17h2V8h4l-6-6z"/></svg>
              </button>
            </div>
            {/* <div className="col-2">
              <button className="" onClick={() => navigate("/Deregistered_splist")} style={{ boxShadow: "3px 5px 10px rgba(0,0,0,0.2)", height: "40px", fontSize: "small",  color: "white", backgroundColor: "#272244", border: "none",borderRadius:"5px" }}>
              Deregistered Clinics  <i class="fa fa-arrow-right" aria-hidden="true"></i>
              </button>
            </div> */}
      </div>}
            </div><br/>

              <div className="" style={{margin:"auto"}}>
                <div className="container" style={{}}>
                  <div className="test-reports-display-list">
                    {display ? <>
                      <div className="row " style={{ backgroundColor: "rgba(85, 71, 159, 0.72)", color: "white", textAlign: "left",padding:"1%", borderRadius:"5px 5px 0px 0px", boxShadow:" 2px 2px 7px rgb(0 0 0 / 30%)",marginBottom:"0.5%",fontSize:"12px"}}>
                      <div  className="col-1"><b>ID</b></div>
                    <div  className={selected==="approved"?"col-2":"col-3"}><b>Service provider</b></div>
                   {selected==="approved"&& <div className="col-1"><b >Patients</b></div>}
                    <div className="col-2"><b >Category</b></div>
                    <div className="col-2"><b >Type </b></div>
                   
                    <div className="col-2"><b >Date</b></div>
                    <div className="col-2"><b >Location</b></div>
                    
                    
                </div>
                      {display}
                      </> : (
                      <div style={{ color: "", fontSize: "20px", height: "200px", padding: "10%" }}>
                       {!loading? <h5>{selected==="approved"?"No more approved list to show!!":selected==="pending"?"No more pending list to show!!":selected==="rejected"?"No more rejected list to show!!":"No more expired list to show!!"}</h5>:""}
                      </div>
                    )}
                  </div>

                </div>
              </div>

              {totalPages > 1 ?
                <div className="pagn pagn-small">
                  <br />
                  <br />
                  <br />
                  <Pagination
                    activePage={currentPage}
                    itemsCountPerPage={perPage}
                    totalItemsCount={total}
                    pageRangeDisplayed={totalPages}
                    onChange={handlePageChange}
                    disabledClass="disabled-class"
                  />
                </div>
                : null}

            </div>
          </div>
        
      </div>
  )
}

export default RegisteredHospitals
